import {Injectable} from '@angular/core';
import {PaymentCardReaderModel} from "../paymentCardReader.model";
import {PaymentCardReaderSummaryConverter} from "./paymentCardReaderSummary.converter";
import {HttpModelConverter} from "../../../../../../../core/converter/httpModel.converter";
import {ValueAndLabelConverter} from "../../../../../../../common/converter/ValueAndLabel.converter";

@Injectable({
    providedIn: 'root'
})
export class PaymentCardReaderConverter extends HttpModelConverter<PaymentCardReaderModel> {
    constructor(private summaryConverter: PaymentCardReaderSummaryConverter,
                private valueAndLabelConverter: ValueAndLabelConverter) {
        super();
    }

    protected createInstance(): PaymentCardReaderModel {
        return new PaymentCardReaderModel();
    }

    protected enrichObject(result: PaymentCardReaderModel, src: PaymentCardReaderModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.status = this.valueAndLabelConverter.convert(src.status);
    }
}
